import { render } from "./MRedemptionDetails.vue?vue&type=template&id=48831d6a&scoped=true&ts=true"
import script from "./MRedemptionDetails.vue?vue&type=script&lang=ts"
export * from "./MRedemptionDetails.vue?vue&type=script&lang=ts"

import "./MRedemptionDetails.vue?vue&type=style&index=0&id=48831d6a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48831d6a"]])

export default __exports__